import { enableNsfwMode } from "../components/enableNsfwMode";

function pageHome() {
    function initFeaturesMasonry() {
        $('.grid-masonry').each(function () {
            let $grid = $(this);
            let $items = $grid.find('.b-features-single');
            let gridWidth = $grid.innerWidth();
            let columns = window.innerWidth >= 768 ? 2 : 1;
            let columnWidth = gridWidth / columns;
            let columnHeights = Array(columns).fill(0);

            $grid.css({
                position: 'relative',
                height: ''
            });

            if ($grid.data('masonry')) {
                $grid.masonry('destroy');
            }

            $items.each(function (index) {
                let $item = $(this);
                let columnIndex = columns === 1 ? 0 : index % columns;
                let top = columnHeights[columnIndex];
                let left = columnWidth * columnIndex;

                $item.css({
                    position: 'absolute',
                    left: `${left}px`,
                    top: `${top}px`,
                    width: `${columnWidth}px`
                });

                columnHeights[columnIndex] += $item.outerHeight();
            });

            $grid.css('height', `${Math.max(...columnHeights)}px`);
        });
    }

    $(document).ready(function () {
        enableNsfwMode();

        initFeaturesMasonry();

        $(window).on('load', function () {
            initFeaturesMasonry();
        });

        let masonryResizeTimer = null;
        $(window).on('resize', function () {
            clearTimeout(masonryResizeTimer);
            masonryResizeTimer = setTimeout(function () {
                initFeaturesMasonry();
            }, 100);
        });
    })

    // $('#characters').masonry({
    //     // columnWidth: 0,
    //     itemSelector: '.growtype-post-single'
    // });

    /**
     * Change modal f img
     */
    $('.growtype-post-single-inner[data-bs-target="#growtypeWcSubscriptionModal"]').click(function () {
        $('#growtypeWcSubscriptionModal .modal-body .featured-img').css('background-image', 'url(' + $(this).attr('data-featured-img-url') + ')');
    });

    /**
     * Trackign
     */
    $('.growtype-post-avatar').click(function () {
        let character = $(this);
        let id = character.find('.growtype-post-single-inner').attr('data-id');
        let title = character.find('.growtype-post-single-inner').attr('data-character-title');

        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "click_character",
                title: title,
                id: id,
            });
        }
    });

    /**
     * Tracking
     */
    $('.growtype-post-terms-filter-btn').click(function () {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "click_cat_characters",
                title: $(this).text(),
            });
        }
    });

    /**
     * Particles
     */
    if ($('#particles-js').length > 0 && typeof particlesJS !== 'undefined') {
        particlesJS("particles-js", {
            "particles": {
                "number": {
                    "value": 355,
                    "density": {
                        "enable": true,
                        "value_area": 789.1476416322727
                    }
                },
                "color": {
                    "value": "#ffffff"
                },
                "shape": {
                    "type": "circle",
                    "stroke": {
                        "width": 0,
                        "color": "#000000"
                    },
                    "polygon": {
                        "nb_sides": 5
                    },
                    "image": {
                        "src": "img/github.svg",
                        "width": 100,
                        "height": 100
                    }
                },
                "opacity": {
                    "value": 0.48927153781200905,
                    "random": false,
                    "anim": {
                        "enable": true,
                        "speed": 0.2,
                        "opacity_min": 0,
                        "sync": false
                    }
                },
                "size": {
                    "value": 2,
                    "random": true,
                    "anim": {
                        "enable": true,
                        "speed": 2,
                        "size_min": 0,
                        "sync": false
                    }
                },
                "line_linked": {
                    "enable": false,
                    "distance": 150,
                    "color": "#ffffff",
                    "opacity": 0.4,
                    "width": 1
                },
                "move": {
                    "enable": true,
                    "speed": 1,
                    "direction": "none",
                    "random": true,
                    "straight": false,
                    "out_mode": "out",
                    "bounce": false,
                    "attract": {
                        "enable": false,
                        "rotateX": 600,
                        "rotateY": 1200
                    }
                }
            },
            "interactivity": {
                "detect_on": "canvas",
                "events": {
                    "onhover": {
                        "enable": true,
                        "mode": "bubble"
                    },
                    "onclick": {
                        "enable": true,
                        "mode": "push"
                    },
                    "resize": true
                },
                "modes": {
                    "grab": {
                        "distance": 400,
                        "line_linked": {
                            "opacity": 1
                        }
                    },
                    "bubble": {
                        "distance": 83.91608391608392,
                        "size": 1,
                        "duration": 3,
                        "opacity": 1,
                        "speed": 3
                    },
                    "repulse": {
                        "distance": 200,
                        "duration": 0.4
                    },
                    "push": {
                        "particles_nb": 4
                    },
                    "remove": {
                        "particles_nb": 2
                    }
                }
            },
            "retina_detect": true
        });
    }

    /**
     * Subscription modal
     */
    document.addEventListener('DOMContentLoaded', () => {
        // Modal Elements
        const modalElements = [
            document.getElementById('growtypeWcSubscriptionModal'),
            document.getElementById('growtypeChatExtraCreditsModal')
        ].filter(Boolean); // Filter out null elements

        modalElements.forEach((modalElement) => {
            if (!modalElement) return;

            // Modal Title Element
            const modalTitle = modalElement.querySelector('.modal-title');

            // Store original title if not already stored
            if (modalTitle && !modalTitle.hasAttribute('data-original-title')) {
                modalTitle.setAttribute('data-original-title', modalTitle.textContent);
            }

            // Bootstrap Modal Show Event
            modalElement.addEventListener('show.bs.modal', (event) => {
                const button = event.relatedTarget;
                if (button) {
                    const title = button.getAttribute('data-title') || modalTitle.getAttribute('data-original-title');
                    if (title) {
                        modalTitle.textContent = title;
                    }
                }

                // Initialize the slider
                const $slider = $(modalElement).find('.growtype-theme-slider');

                if ($slider.length && $.fn.slick) {
                    try {
                        $slider.slick('unslick');
                    } catch (e) {
                        // Ignore if not slicked
                    }

                    setTimeout(() => {
                        try {
                            const sliderSettings = JSON.parse($slider.attr('data-gslick'));
                            $slider.slick(sliderSettings);
                        } catch (error) {
                            console.error('Failed to parse slider settings:', error.message);
                        }
                    }, 200);
                }
            });
        });
    });
}

export { pageHome };
